import type { AxiosCollection, AxiosErrors } from '@/types/Components/Response'
import type { AuditLogItem } from '@/types/Models/AuditLog'
import type { AuditLogStoreState } from '@/types/Store'
import { defineStore } from 'pinia'
import { catchErrors } from '@/services/Helpers'
import { isSameObject } from '@/services/Utils'
import AuditLogProxy from '@/proxies/AuditLogProxy'

const createDefaultState = (): AuditLogStoreState => ({
  logs: [],
  count: 0,
  loading: false,
  filter: null,
})

export const useAuditLogStore = defineStore('auditLog', {
  state: (): AuditLogStoreState => createDefaultState(),
  actions: {
    fetch() {
      this.loading = true

      new AuditLogProxy(this.filter || undefined)
        .all()
        .then((response: AxiosCollection<AuditLogItem>) => {
          this.logs = response.data || []
          this.count = response.count || 0
        })
        .catch((error: AxiosErrors) => {
          this.logs = []
          this.count = 0
          catchErrors(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setFilter(filter: Record<string, string | null> | null) {
      if (isSameObject(filter, this.filter)) return

      this.filter = filter
      this.fetch()
    },
    updateFilter(partialFilter: Record<string, string | null>) {
      const filter = {
        ...(this.filter ?? {}),
        ...partialFilter,
      }

      if (isSameObject(filter, this.filter)) return

      this.filter = filter
      this.fetch()
    },
    unmount() {
      Object.assign(this, createDefaultState())
    },
  },
})

export type AuditLogStore = ReturnType<typeof useAuditLogStore>

